import React, { useEffect, useMemo, useRef, useState } from 'react'
import { FaLongArrowAltRight } from 'react-icons/fa'
import { RxTriangleRight } from 'react-icons/rx'
import { useNavigate } from 'react-router-dom'
import styles from "./About.module.css"
export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])
    // //console.log(isInters ecting);
    return isIntersecting
}
function About(props) {
    const navigate = useNavigate()
    const ref = useRef()
    const isVisible = useOnScreen(ref)
    return (
        <div className={styles.about}>
            <h3 style={{ color: "#066263" }}>会社概要</h3>
            <div className={styles.aboutcontainer}>
                <div style={{ textAlign: "center" }}>
                    <p className={styles.englishName}>SHARVIL Business Group</p>
                    <p className={styles.englishNameTwo}>株式会社SHARVIL</p>
                    <p className={styles.englishNameTwo}> SHARVIL,Inc.</p>
                </div>

                <div ref={ref} className={`${styles.info} ${isVisible ? styles.show : styles.hide}`}>
                    <div className={`${styles.aboutInfocontainer}`}>
                        <div className={styles.workdGridItem}>
                            <p style={{ paddingLeft: "40px" }}>日本オフィス</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p>〒606-8241  <br /> 京都府京都市左京区田中西高原町24番地</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p style={{ paddingLeft: "40px" }}>インドオフィス</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p style={{ fontFamily: 'Avenir Next regular' }}>SHARVIL Business Private Limited, <br />
                                12/492 Batra Colony, Rishi Nagar, Sonipat, Haryana – 131001</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p style={{ paddingLeft: "40px" }}>設立</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p>2020年8月</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p style={{ fontFamily: 'Avenir Next regular', paddingLeft: "40px" }}>CEO</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <p style={{ fontFamily: 'Avenir Next regular' }}>Shreshth Sapra</p>
                        </div>
                    </div>
                </div>

            </div>

            {!props.about && <div className={`${styles.WwhyUsbutton} mobileButton`}>
                <button onClick={() => navigate('/about')}>About Us<RxTriangleRight /> </button>

            </div>}
        </div>

    )
}

export default About